import { type PivotCellAttributes } from './generated/PivotCellAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';

interface PivotCell extends PivotCellAttributes {}

@model
class PivotCell extends ApplicationModel {
  // Start auto-generated
  static typename: 'PivotCell' = 'PivotCell';
  get typename(): 'PivotCell' {
    return 'PivotCell';
  }

  static fields = {
    value: attr({ readable: true }),
    pivotColumn: attr.belongsTo({ readable: true, typename: 'PivotColumn' }),
  };
  // End auto-generated

  // We don't actually write the value back to the server, this is just for display purposes
  set value(newValue: string) {
    this.setAttribute('value', newValue);
  }
}

export default PivotCell;
